__turbopack_context__.v({
  "content": "Popover-module-scss-module__76B3yq__content",
});
